import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/buttons';
import CircleCrossIcon from '@/assets/icons/heroIcons/Circle-cross.svg';
import { Headline, Text } from '@/components/typography';
export const Fail = t0 => {
  const $ = _c(19);
  const {
    onRetry
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["insuranceReport", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CircleCrossIcon className="mx-auto h-10 w-10" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("insuranceReport:fail.title");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <Headline as="h2" variant="h4">{t3}</Headline>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("insuranceReport:fail.text");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <Text>{t5}</Text>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t("insuranceReport:fail.cta");
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== onRetry || $[13] !== t7) {
    t8 = <Button type="button" variant="primary" size="lg" align="center" onClick={onRetry} analyticsParam="insuranceReportRetry" testId="insuranceReportRetry">{t7}</Button>;
    $[12] = onRetry;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t6 || $[17] !== t8) {
    t9 = <div className="flex flex-col gap-6 text-center">{t2}{t4}{t6}{t8}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};